import { Button, useTheme } from "@mui/material";

const ShadowedButton = (props: any) => {
    const theme = useTheme();
    const buttonColor = props.color;
    const existingHoverEffects = props.sx ? props.sx["&:hover"] : "";
    let shadowColor = "";

    if (buttonColor === "success") {
        shadowColor = theme.palette.success.main;
    } else if (buttonColor === "error") {
        shadowColor = theme.palette.error.main;
    } else if (buttonColor === "primary") {
        shadowColor = theme.palette.primary.main;
    } else if (buttonColor === "secondary") {
        shadowColor = theme.palette.secondary.main;
    } else if (buttonColor === "info") {
        shadowColor = theme.palette.info.main;
    } else if (buttonColor === "warning") {
        shadowColor = theme.palette.warning.main;
    } else {
        shadowColor = theme.palette.grey[500];
    }

    const buttonProps = {
        ...props,
        sx: {
            ...props.sx,
            "@media (min-width: 1024px)": {
                "&:hover": {
                    boxShadow: "0 5px 10px rgba(206, 19, 55, 0.1)", // Adds the red shadow effect
                    ...existingHoverEffects,
                },
            },
        },
    };

    return <Button {...buttonProps} />;
};

export default ShadowedButton;
